import { render, staticRenderFns } from "./contractStandard.vue?vue&type=template&id=3b6d3efe&scoped=true"
import script from "./contractStandard.vue?vue&type=script&lang=js"
export * from "./contractStandard.vue?vue&type=script&lang=js"
import style0 from "./contractStandard.vue?vue&type=style&index=0&id=3b6d3efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6d3efe",
  null
  
)

export default component.exports